import { ActionTypes } from '../constants/index';

export const fetchCommissionRules = (payload: any) => ({
  type: ActionTypes.COMMISSION_RULES_REQUEST,
  payload,
});